import { useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'

interface LayoutProps {
  children: React.ReactNode
  currentPage: string
  onLogout: () => void
  onPageChange: (page: string) => void
  userInfo: {
    email: string
    fullName: string
    isAdmin: boolean
    permissions: string[]
  }
}

export default function Layout({ children, currentPage, onLogout, onPageChange, userInfo }: LayoutProps) {
  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      {/* 사이드바 */}
      <Sidebar currentPage={currentPage} userInfo={userInfo} onPageChange={onPageChange} />
      
      {/* 메인 콘텐츠 영역 */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {/* 헤더 */}
        <Header 
          currentPage={currentPage} 
          userInfo={userInfo} 
          onLogout={onLogout} 
        />
        
        {/* 메인 콘텐츠 */}
        <main style={{ 
          flex: 1, 
          padding: '24px', 
          backgroundColor: 'white',
          overflow: 'auto'
        }}>
          {children}
        </main>
      </div>
    </div>
  )
}
